module.exports = __webpack_public_path__ + "img/not-authorized.a4e10e0e.svg";